export default "/images/delivery.svg?36a1b736c1fcbf8fdca5447f4c7aec7b";